window.addEventListener('load',()=>{
    const hook = setInterval(()=>{
        let gdprLabel = document.querySelector('label[for="esc-gdpr-input"]');
        if (gdprLabel && gdprLabel.childNodes[1].textContent != "I agree to receive personalised marketing emails from this store." ){
            gdprLabel.childNodes[1].textContent = 'I agree to receive personalised marketing emails from this store.';
        }
        setTimeout(()=>{
            clearInterval(hook)
        },15000);
    })
  })